module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAMAAACOacfrAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABVQTFRFAAAAzMzMo6Oj5eXlgoKCaGho/f39iySGTQAAAAd0Uk5T////////ABpLA0YAAAAqSURBVHjaYmBAADY2BmSAymPALQfUxwYCEJKaPEYmBlYWJkZmNjaAAAMAckQCBYTNkoEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/location.png
// module id = 7
// module chunks = 0 1